import { DiscardConfirmationRecord, TurndownOutcome, TurndownRecord } from '@/api/apis/case';
import { formatDate } from '@/utils/helpers';

export const getDiscardDescription = (
  discardConfirmationFormData?: DiscardConfirmationRecord,
  turndownOutcome?: TurndownOutcome,
  oneLungTurndown?: TurndownRecord,
) => {
  const organDiscarded = turndownOutcome === TurndownOutcome.DiscardOrgan;

  if (organDiscarded && discardConfirmationFormData) {
    const { ocsSpecialist, unosId, txCenter, nurse, opoFullName, organType, timeZone, timestamp } =
      discardConfirmationFormData.item;
    const discardedOrgan = oneLungTurndown ? `${oneLungTurndown.item?.lung} lung` : organType;
    const datetime = formatDate(timestamp, 'MM/dd/yyyy HH:mm zzz', { timezone: timeZone });

    return `${ocsSpecialist?.signature.fullName} discarded ${discardedOrgan}
       ${unosId} under visitor or with the help of
       ${txCenter?.name} nurse ${nurse?.signature.fullName}
       per OPO ${opoFullName} recommendation on ${datetime}`;
  }

  return '';
};
